import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'whatwg-fetch';
import VueApollo from 'vue-apollo';

import di from 'di';

import bootstraps from 'app/bootstrap';
import App from 'app/components/App.vue';


// Bootstrap
bootstraps.forEach(strap => strap());

// Run
const router = di.get('router');
const i18n = di.get('i18n');
const acl = di.get('acl');
const auth = di.get('auth');

const apolloProvider = new VueApollo({
    defaultClient: di.get('apollo')
});


const run = () => {

    new App({
        'el': '#app-wrapper',
        apolloProvider,
        router,
        i18n,
        acl,
        auth,
        breadcrumb: true,
        overlay: true,
        toast: true
    });

    document.getElementsByClassName('full-screen-loader')[0].classList.remove('cloak');
};

run();
